<template>
  <ClientWithoutCalling module="sales" />
</template>

<script>
import ClientWithoutCalling from "@/components/sales/kpi/ClientWithoutCalling.vue";

export default {
  name: "ClientWithoutCallingSales",
  components: {
    ClientWithoutCalling
  }
};
</script>
